export default [
  { id: 1, name: 'Регион 0' },
  { id: 2, name: 'Регион 1' },
  { id: 3, name: 'Регион 2' },
  { id: 4, name: 'Регион 3' },
  { id: 5, name: 'Регион 4' },
  { id: 6, name: 'Регион 5' },
  { id: 7, name: 'Регион 6' },
  { id: 8, name: 'Регион 7' },
  { id: 9, name: 'Регион 8' },
  { id: 10, name: 'Регион 9' },
  { id: 11, name: 'Регион 20' },
  { id: 12, name: 'Технический регион' },
];
